import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@pg-app/core/services/auth.guard';
import { ChangePasswordComponent } from '@pg-app/common/change-password/change-password.component';
import { ChangeMemorableNumberComponent } from '@pg-app/common/change-memorable-number/change-memorable-number.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'referral',
        loadChildren: () => import('./referral/referral.module').then(m => m.ReferralModule)
      },
      {
        path: 'search-referral',
        loadChildren: () => import('./search-referral/search-referral.module').then(m => m.SearchReferralModule)
      },
      {
        path: 'user-profile',
        loadChildren: () => import('./user-profile/user-profile.module').then(m => m.UserProfileModule)
      },
      {
        path: 'manage-user',
        loadChildren: () => import('./manage-user/manage-user.module').then(m => m.ManageUserModule)
      },
      {
        path: 'register/step-2',
        loadChildren: () => import('./partner-register-step2/partner-register-step2.module').then(m => m.PartnerRegisterStep2Module)
      },
      {
        path: 'commission-report',
        loadChildren: () => import('./commission-report/commission-report.module').then(m => m.CommissionReportModule),
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent
      },
      {
        path: 'change-memorable-number',
        component: ChangeMemorableNumberComponent
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartnerRoutingModule { }
